import { z as e } from "zod";
import { jsx as ir } from "react/jsx-runtime";
import { memoize as gt, noop as or } from "lodash-es";
import { createContext as cr, useContext as lr, useEffect as ur } from "react";
import { validateChecksumAddress as fr, validateAndParseAddress as hr, getChecksumAddress as pr, num as ze, constants as dr, CairoCustomEnum as mr } from "starknet";
import "swr";
function Er(n) {
  var p = [];
  if (n.length === 0)
    return "";
  if (typeof n[0] != "string")
    throw new TypeError("Url must be a string. Received " + n[0]);
  if (n[0].match(/^[^/:]+:\/*$/) && n.length > 1) {
    var R = n.shift();
    n[0] = R + n[0];
  }
  n[0].match(/^file:\/\/\//) ? n[0] = n[0].replace(/^([^/:]+):\/*/, "$1:///") : n[0] = n[0].replace(/^([^/:]+):\/*/, "$1://");
  for (var _ = 0; _ < n.length; _++) {
    var S = n[_];
    if (typeof S != "string")
      throw new TypeError("Url must be a string. Received " + S);
    S !== "" && (_ > 0 && (S = S.replace(/^[\/]+/, "")), _ < n.length - 1 ? S = S.replace(/[\/]+$/, "") : S = S.replace(/[\/]+$/, "/"), p.push(S));
  }
  var B = p.join("/");
  B = B.replace(/\/(\?|&|#[^!])/g, "$1");
  var M = B.split("?");
  return B = M.shift() + (M.length > 0 ? "?" : "") + M.join("&"), B;
}
function gr() {
  var n;
  return typeof arguments[0] == "object" ? n = arguments[0] : n = [].slice.call(arguments), Er(n);
}
const It = e.string().refine((n) => {
  if (n.toLowerCase() === n)
    return !0;
  try {
    return fr(n) && Or(n);
  } catch {
  }
  return !1;
}, "Invalid address (checksum error)"), Ir = e.string().refine((n) => {
  try {
    return hr(n);
  } catch {
  }
  return !1;
}, "Invalid address (validation error)"), ke = e.string().regex(/^0x[0-9a-fA-F]+$/, "Invalid address"), Ar = ke.min(50, "Addresses must at least be 50 characters long").max(66, "Addresses must at most be 66 characters long"), Nr = ke.length(66, "Address must be 66 characters long"), Te = Ar.pipe(It).transform((n) => `0x${(n.startsWith("0x") ? n.slice(2) : n).padStart(64, "0")}`), xn = Te.or(e.literal("")).transform((n) => n === "" ? void 0 : n).optional(), q = ke.transform((n) => `0x${n.replace(/^0x/, "").toLowerCase().padStart(64, "0")}`), Sr = (n) => Te.safeParse(n).success, Rr = Sr, Ue = (n) => pr(n), Mn = (n) => {
  const p = Ue(n), R = p.slice(0, 2), _ = p.slice(2, 6), S = p.slice(-4);
  return `${R}${_}…${S}`;
}, Gn = (n) => {
  const p = Ue(n), R = p.slice(0, 2), S = p.slice(2).match(/.{1,4}/g) || [];
  return `${R} ${S.join(" ")}`;
}, Or = (n) => !/^0x[0-9a-f]{63,64}$/.test(n), vr = (n, p) => {
  try {
    return !n || !p ? !1 : ze.hexToDecimalString(n) === ze.hexToDecimalString(p);
  } catch {
  }
  return !1;
}, Tr = (n) => {
  try {
    return ze.toBigInt(ke.parse(n)) === dr.ZERO;
  } catch {
  }
  return !1;
}, Bn = (n, p) => !!(p != null && p.some((R) => vr(R, n))), $n = gt((n) => {
  const p = n.slice(0, 6), R = n.slice(-4);
  return `${p}…${R}`;
}), Xn = gt((n, p) => {
  if (n.length < p)
    return n;
  const R = Math.floor((p - 1) / 2), _ = n.slice(0, R), S = n.slice(-R);
  return `${_}…${S}`;
}), Vn = e.string().regex(/^[a-zA-Z0-9.-]*$/g, "Invalid address character").max(66, "Address cannot be over 66 characters"), wr = Nr.pipe(It).pipe(Ir), Fe = e.string().regex(/^([a-zA-Z0-9-]+\.)+argent.xyz$/, "Invalid Argent name").max(253, "Argent name cannot be over 253 characters"), yr = (n) => Fe.safeParse(n).success, br = (n, p) => {
  try {
    return p ? qe(n) === qe(p) : !1;
  } catch {
  }
  return !1;
}, qe = (n) => Fe.parse(n).toLowerCase(), nt = e.string().regex(/^([a-zA-Z0-9-]+\.)+stark$/, "Invalid Starknet ID").max(50, "Starknet ID cannot be over 50 characters"), Lr = (n) => nt.safeParse(n).success, Cr = (n, p) => {
  try {
    return p ? We(n) === We(p) : !1;
  } catch {
  }
  return !1;
}, We = (n) => nt.parse(n).toLowerCase(), at = e.union([
  Fe,
  nt
]), Hn = e.union([
  Te,
  at
]), zn = e.union([
  wr,
  at
]), qn = (n) => at.safeParse(n).success, Wn = (n, p) => {
  try {
    return p ? br(n, p) || Cr(n, p) : !1;
  } catch {
  }
  return !1;
}, Yn = (n) => Lr(n) ? We(n) : yr(n) ? qe(n) : Ue(n), _r = e.union([e.literal("0"), e.literal("1")]), Zn = "0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7", Kn = "0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d", Jn = "0x1a736d6ed154502257f02b1ccdf4d9d1089f80811cd6acad48e6b6a9d1f2003", Qn = "0x036078334509b514626504edc9fb252328d1a240e4e948bef8d0c08dff45927f", ea = "0x737ee2f87ce571a58c6c8da558ec18a07ceb64a6172d5ec46171fbc80077a48", ta = "0x6e150953b26271a740bf2b6e9bca17cc52c68d765f761295de51ceb8526ee72", ra = "0x4d07e40e93398ed3c76981e72dd1fd22557a78ce36c0515f679e27f0bb5bc5f";
class xe extends Error {
  constructor({ code: p, message: R, options: _ = {} }, S) {
    const { error: B, context: M } = _;
    super(R, { cause: B }), this.errorMessages = S, this.name = "BaseError", this.context = M, this.code = p, this.setMessageByCode(p, R);
  }
  setMessageByCode(p, R) {
    !p || !this.errorMessages || R || (this.message = this.errorMessages[p]);
  }
}
var Ye;
(function(n) {
  n.NOT_VALID = "Invalid address", n.NOT_FOUND = "Address not found", n.STARKNAME_NOT_FOUND = "Stark name not found", n.STARKNAME_ERROR = "Could not get address from stark name", n.STARKNAME_INVALID_ADDRESS = "Stark name resolved to an invalid address", n.ARGENT_NAME_NOT_FOUND = "Argent name not found", n.NO_ADDRESS_FROM_ARGENT_NAME = "Could not get address from Argent name", n.ARGENT_NAME_INVALID_ADDRESS = "Argent name resolved to an invalid address", n.NO_ADDRESS_FROM_DOMAIN = "Could not get address from domain", n.ARGENT_NAME_INVALID_NETWORK = "Argent name is not enabled on the requested network";
})(Ye || (Ye = {}));
class _e extends xe {
  constructor(p) {
    super(p, Ye), this.name = "AddressError";
  }
}
class st extends Error {
  constructor(p, R, _) {
    super(p), this.status = R, this.data = _, Object.setPrototypeOf(this, st.prototype);
  }
}
var lt;
(function(n) {
  n.FAILED_TO_FETCH_URL = "Failed to fetch url", n.FAILED_TO_POST_URL = "Failed to post url";
})(lt || (lt = {}));
const na = e.object({
  walletAddress: q,
  ens: Fe,
  chain: e.enum(["ethereum", "starknet"]),
  deleted: e.boolean(),
  walletDeployed: e.boolean()
}).or(e.object({
  status: e.string()
}));
async function aa(n, p, R, _ = "starknet") {
  const S = {
    ens: n,
    chain: _
  }, B = new URLSearchParams(S), M = gr(R, "wallet", `?${B}`);
  try {
    const F = await p.get(M), L = F && "walletAddress" in F ? F.walletAddress : void 0;
    if (!L)
      throw new _e({
        code: "NO_ADDRESS_FROM_ARGENT_NAME"
      });
    if (Tr(L))
      throw new _e({
        code: "ARGENT_NAME_NOT_FOUND",
        message: `${n} not found`
      });
    if (!Rr(L))
      throw new _e({
        code: "ARGENT_NAME_INVALID_ADDRESS",
        message: `${n} resolved to an invalid address (${L})`
      });
    return Ue(L);
  } catch (F) {
    throw F instanceof st && F.status === 404 ? new _e({
      code: "ARGENT_NAME_NOT_FOUND",
      message: `${n} not found`
    }) : F;
  }
}
var Ze;
(function(n) {
  n.NOT_VALID = "Invalid call";
})(Ze || (Ze = {}));
class sa extends xe {
  constructor(p) {
    super(p, Ze), this.name = "CallError";
  }
}
var Ke;
(function(n) {
  n.NO_NETWORK_OR_MULTICALL = "Missing networkId or multicall", n.NOT_FOUND = "Network not found";
})(Ke || (Ke = {}));
class ia extends xe {
  constructor(p) {
    super(p, Ke), this.name = "NetworkError";
  }
}
const Le = e.union([e.string(), e.number(), e.bigint()]), Dr = e.object({
  low: Le,
  high: Le
}), Pr = e.array(e.string()).and(e.object({
  __compiled__: e.boolean().optional()
}).optional()), jr = e.lazy(() => e.array(e.union([je, e.array(je), it]))), je = e.union([
  Le,
  Dr,
  e.any(),
  e.boolean()
]), kr = e.lazy(() => e.record(e.union([je, e.array(je), it]))), it = e.lazy(() => e.union([kr, jr])), Ur = e.lazy(() => e.object({
  contractAddress: e.string(),
  calldata: e.union([it, Pr]).optional(),
  entrypoint: e.string().optional()
})), oa = e.lazy(() => Ur.and(e.object({
  entrypoint: e.string()
}))), ue = e.string().refine((n) => typeof parseInt(n) == "number"), ca = e.tuple([ue]), la = e.tuple([ue]), ua = e.object({
  new_threshold: e.string().refine((n) => typeof parseInt(n) == "number"),
  signers_to_add: e.array(ue)
}), fa = e.object({
  new_threshold: e.string().refine((n) => typeof parseInt(n) == "number"),
  signers_to_remove: e.array(ue)
}), ha = e.object({
  signer_to_remove: ue,
  signer_to_add: ue
}), pa = e.tuple([ue]), da = e.tuple([ue]), ma = e.tuple([ue]), Ea = e.tuple([ue]).rest(ue), ga = e.object({
  recipient: Te,
  amount: e.object({
    low: Le,
    high: Le
  })
}), Fr = e.string().regex(/^(0x)?[0-9a-fA-F]+$/, "Invalid hex string"), At = Fr.transform((n) => {
  const p = n.startsWith("0x") ? n.slice(2) : n;
  return `0x${p.length % 2 === 0 ? p : `0${p}`}`;
}), Ia = e.object({
  cairoVersion: _r,
  accountClassHash: At
}), xr = e.array(e.string()), Aa = e.object({
  implementation: e.string(),
  selector: At,
  calldata: xr
}), Na = e.object({
  owner: e.string(),
  guardian: e.string().optional().transform((n) => n ?? "0")
});
var ut;
(function(n) {
  n.Starknet = "Starknet", n.Secp256k1 = "Secp256k1", n.Secp256r1 = "Secp256r1", n.Eip191 = "Eip191", n.Webauthn = "Webauthn";
})(ut || (ut = {}));
function Sa(n, p) {
  const R = {
    Starknet: void 0,
    Secp256k1: void 0,
    Secp256r1: void 0,
    Eip191: void 0,
    Webauthn: void 0
  };
  return R[p] = n, new mr(R);
}
var Je;
(function(n) {
  n.NOT_FOUND = "Account not found", n.CALCULATED_ADDRESS_NO_MATCH = "Calculated address does not match account address";
})(Je || (Je = {}));
class Ra extends xe {
  constructor(p) {
    super(p, Je), this.name = "AccountError";
  }
}
function Mr(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Qe = { exports: {} };
(function(n, p) {
  p = n.exports = C;
  var R;
  typeof process == "object" && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? R = function() {
    var t = Array.prototype.slice.call(arguments, 0);
    t.unshift("SEMVER"), console.log.apply(console, t);
  } : R = function() {
  }, p.SEMVER_SPEC_VERSION = "2.0.0";
  var _ = 256, S = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
  9007199254740991, B = 16, M = _ - 6, F = p.re = [], L = p.safeRe = [], I = p.src = [], m = p.tokens = {}, J = 0;
  function D(t) {
    m[t] = J++;
  }
  var me = "[a-zA-Z0-9-]", ae = [
    ["\\s", 1],
    ["\\d", _],
    [me, M]
  ];
  function Ee(t) {
    for (var i = 0; i < ae.length; i++) {
      var c = ae[i][0], A = ae[i][1];
      t = t.split(c + "*").join(c + "{0," + A + "}").split(c + "+").join(c + "{1," + A + "}");
    }
    return t;
  }
  D("NUMERICIDENTIFIER"), I[m.NUMERICIDENTIFIER] = "0|[1-9]\\d*", D("NUMERICIDENTIFIERLOOSE"), I[m.NUMERICIDENTIFIERLOOSE] = "\\d+", D("NONNUMERICIDENTIFIER"), I[m.NONNUMERICIDENTIFIER] = "\\d*[a-zA-Z-]" + me + "*", D("MAINVERSION"), I[m.MAINVERSION] = "(" + I[m.NUMERICIDENTIFIER] + ")\\.(" + I[m.NUMERICIDENTIFIER] + ")\\.(" + I[m.NUMERICIDENTIFIER] + ")", D("MAINVERSIONLOOSE"), I[m.MAINVERSIONLOOSE] = "(" + I[m.NUMERICIDENTIFIERLOOSE] + ")\\.(" + I[m.NUMERICIDENTIFIERLOOSE] + ")\\.(" + I[m.NUMERICIDENTIFIERLOOSE] + ")", D("PRERELEASEIDENTIFIER"), I[m.PRERELEASEIDENTIFIER] = "(?:" + I[m.NUMERICIDENTIFIER] + "|" + I[m.NONNUMERICIDENTIFIER] + ")", D("PRERELEASEIDENTIFIERLOOSE"), I[m.PRERELEASEIDENTIFIERLOOSE] = "(?:" + I[m.NUMERICIDENTIFIERLOOSE] + "|" + I[m.NONNUMERICIDENTIFIER] + ")", D("PRERELEASE"), I[m.PRERELEASE] = "(?:-(" + I[m.PRERELEASEIDENTIFIER] + "(?:\\." + I[m.PRERELEASEIDENTIFIER] + ")*))", D("PRERELEASELOOSE"), I[m.PRERELEASELOOSE] = "(?:-?(" + I[m.PRERELEASEIDENTIFIERLOOSE] + "(?:\\." + I[m.PRERELEASEIDENTIFIERLOOSE] + ")*))", D("BUILDIDENTIFIER"), I[m.BUILDIDENTIFIER] = me + "+", D("BUILD"), I[m.BUILD] = "(?:\\+(" + I[m.BUILDIDENTIFIER] + "(?:\\." + I[m.BUILDIDENTIFIER] + ")*))", D("FULL"), D("FULLPLAIN"), I[m.FULLPLAIN] = "v?" + I[m.MAINVERSION] + I[m.PRERELEASE] + "?" + I[m.BUILD] + "?", I[m.FULL] = "^" + I[m.FULLPLAIN] + "$", D("LOOSEPLAIN"), I[m.LOOSEPLAIN] = "[v=\\s]*" + I[m.MAINVERSIONLOOSE] + I[m.PRERELEASELOOSE] + "?" + I[m.BUILD] + "?", D("LOOSE"), I[m.LOOSE] = "^" + I[m.LOOSEPLAIN] + "$", D("GTLT"), I[m.GTLT] = "((?:<|>)?=?)", D("XRANGEIDENTIFIERLOOSE"), I[m.XRANGEIDENTIFIERLOOSE] = I[m.NUMERICIDENTIFIERLOOSE] + "|x|X|\\*", D("XRANGEIDENTIFIER"), I[m.XRANGEIDENTIFIER] = I[m.NUMERICIDENTIFIER] + "|x|X|\\*", D("XRANGEPLAIN"), I[m.XRANGEPLAIN] = "[v=\\s]*(" + I[m.XRANGEIDENTIFIER] + ")(?:\\.(" + I[m.XRANGEIDENTIFIER] + ")(?:\\.(" + I[m.XRANGEIDENTIFIER] + ")(?:" + I[m.PRERELEASE] + ")?" + I[m.BUILD] + "?)?)?", D("XRANGEPLAINLOOSE"), I[m.XRANGEPLAINLOOSE] = "[v=\\s]*(" + I[m.XRANGEIDENTIFIERLOOSE] + ")(?:\\.(" + I[m.XRANGEIDENTIFIERLOOSE] + ")(?:\\.(" + I[m.XRANGEIDENTIFIERLOOSE] + ")(?:" + I[m.PRERELEASELOOSE] + ")?" + I[m.BUILD] + "?)?)?", D("XRANGE"), I[m.XRANGE] = "^" + I[m.GTLT] + "\\s*" + I[m.XRANGEPLAIN] + "$", D("XRANGELOOSE"), I[m.XRANGELOOSE] = "^" + I[m.GTLT] + "\\s*" + I[m.XRANGEPLAINLOOSE] + "$", D("COERCE"), I[m.COERCE] = "(^|[^\\d])(\\d{1," + B + "})(?:\\.(\\d{1," + B + "}))?(?:\\.(\\d{1," + B + "}))?(?:$|[^\\d])", D("COERCERTL"), F[m.COERCERTL] = new RegExp(I[m.COERCE], "g"), L[m.COERCERTL] = new RegExp(Ee(I[m.COERCE]), "g"), D("LONETILDE"), I[m.LONETILDE] = "(?:~>?)", D("TILDETRIM"), I[m.TILDETRIM] = "(\\s*)" + I[m.LONETILDE] + "\\s+", F[m.TILDETRIM] = new RegExp(I[m.TILDETRIM], "g"), L[m.TILDETRIM] = new RegExp(Ee(I[m.TILDETRIM]), "g");
  var ge = "$1~";
  D("TILDE"), I[m.TILDE] = "^" + I[m.LONETILDE] + I[m.XRANGEPLAIN] + "$", D("TILDELOOSE"), I[m.TILDELOOSE] = "^" + I[m.LONETILDE] + I[m.XRANGEPLAINLOOSE] + "$", D("LONECARET"), I[m.LONECARET] = "(?:\\^)", D("CARETTRIM"), I[m.CARETTRIM] = "(\\s*)" + I[m.LONECARET] + "\\s+", F[m.CARETTRIM] = new RegExp(I[m.CARETTRIM], "g"), L[m.CARETTRIM] = new RegExp(Ee(I[m.CARETTRIM]), "g");
  var we = "$1^";
  D("CARET"), I[m.CARET] = "^" + I[m.LONECARET] + I[m.XRANGEPLAIN] + "$", D("CARETLOOSE"), I[m.CARETLOOSE] = "^" + I[m.LONECARET] + I[m.XRANGEPLAINLOOSE] + "$", D("COMPARATORLOOSE"), I[m.COMPARATORLOOSE] = "^" + I[m.GTLT] + "\\s*(" + I[m.LOOSEPLAIN] + ")$|^$", D("COMPARATOR"), I[m.COMPARATOR] = "^" + I[m.GTLT] + "\\s*(" + I[m.FULLPLAIN] + ")$|^$", D("COMPARATORTRIM"), I[m.COMPARATORTRIM] = "(\\s*)" + I[m.GTLT] + "\\s*(" + I[m.LOOSEPLAIN] + "|" + I[m.XRANGEPLAIN] + ")", F[m.COMPARATORTRIM] = new RegExp(I[m.COMPARATORTRIM], "g"), L[m.COMPARATORTRIM] = new RegExp(Ee(I[m.COMPARATORTRIM]), "g");
  var v = "$1$2$3";
  D("HYPHENRANGE"), I[m.HYPHENRANGE] = "^\\s*(" + I[m.XRANGEPLAIN] + ")\\s+-\\s+(" + I[m.XRANGEPLAIN] + ")\\s*$", D("HYPHENRANGELOOSE"), I[m.HYPHENRANGELOOSE] = "^\\s*(" + I[m.XRANGEPLAINLOOSE] + ")\\s+-\\s+(" + I[m.XRANGEPLAINLOOSE] + ")\\s*$", D("STAR"), I[m.STAR] = "(<|>)?=?\\s*\\*";
  for (var re = 0; re < J; re++)
    R(re, I[re]), F[re] || (F[re] = new RegExp(I[re]), L[re] = new RegExp(Ee(I[re])));
  p.parse = fe;
  function fe(t, i) {
    if ((!i || typeof i != "object") && (i = {
      loose: !!i,
      includePrerelease: !1
    }), t instanceof C)
      return t;
    if (typeof t != "string" || t.length > _)
      return null;
    var c = i.loose ? L[m.LOOSE] : L[m.FULL];
    if (!c.test(t))
      return null;
    try {
      return new C(t, i);
    } catch {
      return null;
    }
  }
  p.valid = ye;
  function ye(t, i) {
    var c = fe(t, i);
    return c ? c.version : null;
  }
  p.clean = Q;
  function Q(t, i) {
    var c = fe(t.trim().replace(/^[=v]+/, ""), i);
    return c ? c.version : null;
  }
  p.SemVer = C;
  function C(t, i) {
    if ((!i || typeof i != "object") && (i = {
      loose: !!i,
      includePrerelease: !1
    }), t instanceof C) {
      if (t.loose === i.loose)
        return t;
      t = t.version;
    } else if (typeof t != "string")
      throw new TypeError("Invalid Version: " + t);
    if (t.length > _)
      throw new TypeError("version is longer than " + _ + " characters");
    if (!(this instanceof C))
      return new C(t, i);
    R("SemVer", t, i), this.options = i, this.loose = !!i.loose;
    var c = t.trim().match(i.loose ? L[m.LOOSE] : L[m.FULL]);
    if (!c)
      throw new TypeError("Invalid Version: " + t);
    if (this.raw = t, this.major = +c[1], this.minor = +c[2], this.patch = +c[3], this.major > S || this.major < 0)
      throw new TypeError("Invalid major version");
    if (this.minor > S || this.minor < 0)
      throw new TypeError("Invalid minor version");
    if (this.patch > S || this.patch < 0)
      throw new TypeError("Invalid patch version");
    c[4] ? this.prerelease = c[4].split(".").map(function(A) {
      if (/^[0-9]+$/.test(A)) {
        var O = +A;
        if (O >= 0 && O < S)
          return O;
      }
      return A;
    }) : this.prerelease = [], this.build = c[5] ? c[5].split(".") : [], this.format();
  }
  C.prototype.format = function() {
    return this.version = this.major + "." + this.minor + "." + this.patch, this.prerelease.length && (this.version += "-" + this.prerelease.join(".")), this.version;
  }, C.prototype.toString = function() {
    return this.version;
  }, C.prototype.compare = function(t) {
    return R("SemVer.compare", this.version, this.options, t), t instanceof C || (t = new C(t, this.options)), this.compareMain(t) || this.comparePre(t);
  }, C.prototype.compareMain = function(t) {
    return t instanceof C || (t = new C(t, this.options)), h(this.major, t.major) || h(this.minor, t.minor) || h(this.patch, t.patch);
  }, C.prototype.comparePre = function(t) {
    if (t instanceof C || (t = new C(t, this.options)), this.prerelease.length && !t.prerelease.length)
      return -1;
    if (!this.prerelease.length && t.prerelease.length)
      return 1;
    if (!this.prerelease.length && !t.prerelease.length)
      return 0;
    var i = 0;
    do {
      var c = this.prerelease[i], A = t.prerelease[i];
      if (R("prerelease compare", i, c, A), c === void 0 && A === void 0)
        return 0;
      if (A === void 0)
        return 1;
      if (c === void 0)
        return -1;
      if (c === A)
        continue;
      return h(c, A);
    } while (++i);
  }, C.prototype.compareBuild = function(t) {
    t instanceof C || (t = new C(t, this.options));
    var i = 0;
    do {
      var c = this.build[i], A = t.build[i];
      if (R("prerelease compare", i, c, A), c === void 0 && A === void 0)
        return 0;
      if (A === void 0)
        return 1;
      if (c === void 0)
        return -1;
      if (c === A)
        continue;
      return h(c, A);
    } while (++i);
  }, C.prototype.inc = function(t, i) {
    switch (t) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", i);
        break;
      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", i);
        break;
      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", i), this.inc("pre", i);
        break;
      case "prerelease":
        this.prerelease.length === 0 && this.inc("patch", i), this.inc("pre", i);
        break;
      case "major":
        (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;
      case "minor":
        (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
        break;
      case "patch":
        this.prerelease.length === 0 && this.patch++, this.prerelease = [];
        break;
      case "pre":
        if (this.prerelease.length === 0)
          this.prerelease = [0];
        else {
          for (var c = this.prerelease.length; --c >= 0; )
            typeof this.prerelease[c] == "number" && (this.prerelease[c]++, c = -2);
          c === -1 && this.prerelease.push(0);
        }
        i && (this.prerelease[0] === i ? isNaN(this.prerelease[1]) && (this.prerelease = [i, 0]) : this.prerelease = [i, 0]);
        break;
      default:
        throw new Error("invalid increment argument: " + t);
    }
    return this.format(), this.raw = this.version, this;
  }, p.inc = r;
  function r(t, i, c, A) {
    typeof c == "string" && (A = c, c = void 0);
    try {
      return new C(t, c).inc(i, A).version;
    } catch {
      return null;
    }
  }
  p.diff = a;
  function a(t, i) {
    if (H(t, i))
      return null;
    var c = fe(t), A = fe(i), O = "";
    if (c.prerelease.length || A.prerelease.length) {
      O = "pre";
      var T = "prerelease";
    }
    for (var w in c)
      if ((w === "major" || w === "minor" || w === "patch") && c[w] !== A[w])
        return O + w;
    return T;
  }
  p.compareIdentifiers = h;
  var s = /^[0-9]+$/;
  function h(t, i) {
    var c = s.test(t), A = s.test(i);
    return c && A && (t = +t, i = +i), t === i ? 0 : c && !A ? -1 : A && !c ? 1 : t < i ? -1 : 1;
  }
  p.rcompareIdentifiers = l;
  function l(t, i) {
    return h(i, t);
  }
  p.major = f;
  function f(t, i) {
    return new C(t, i).major;
  }
  p.minor = g;
  function g(t, i) {
    return new C(t, i).minor;
  }
  p.patch = o;
  function o(t, i) {
    return new C(t, i).patch;
  }
  p.compare = u;
  function u(t, i, c) {
    return new C(t, c).compare(new C(i, c));
  }
  p.compareLoose = E;
  function E(t, i) {
    return u(t, i, !0);
  }
  p.compareBuild = d;
  function d(t, i, c) {
    var A = new C(t, c), O = new C(i, c);
    return A.compare(O) || A.compareBuild(O);
  }
  p.rcompare = N;
  function N(t, i, c) {
    return u(i, t, c);
  }
  p.sort = y;
  function y(t, i) {
    return t.sort(function(c, A) {
      return p.compareBuild(c, A, i);
    });
  }
  p.rsort = b;
  function b(t, i) {
    return t.sort(function(c, A) {
      return p.compareBuild(A, c, i);
    });
  }
  p.gt = k;
  function k(t, i, c) {
    return u(t, i, c) > 0;
  }
  p.lt = V;
  function V(t, i, c) {
    return u(t, i, c) < 0;
  }
  p.eq = H;
  function H(t, i, c) {
    return u(t, i, c) === 0;
  }
  p.neq = x;
  function x(t, i, c) {
    return u(t, i, c) !== 0;
  }
  p.gte = X;
  function X(t, i, c) {
    return u(t, i, c) >= 0;
  }
  p.lte = W;
  function W(t, i, c) {
    return u(t, i, c) <= 0;
  }
  p.cmp = Ie;
  function Ie(t, i, c, A) {
    switch (i) {
      case "===":
        return typeof t == "object" && (t = t.version), typeof c == "object" && (c = c.version), t === c;
      case "!==":
        return typeof t == "object" && (t = t.version), typeof c == "object" && (c = c.version), t !== c;
      case "":
      case "=":
      case "==":
        return H(t, c, A);
      case "!=":
        return x(t, c, A);
      case ">":
        return k(t, c, A);
      case ">=":
        return X(t, c, A);
      case "<":
        return V(t, c, A);
      case "<=":
        return W(t, c, A);
      default:
        throw new TypeError("Invalid operator: " + i);
    }
  }
  p.Comparator = K;
  function K(t, i) {
    if ((!i || typeof i != "object") && (i = {
      loose: !!i,
      includePrerelease: !1
    }), t instanceof K) {
      if (t.loose === !!i.loose)
        return t;
      t = t.value;
    }
    if (!(this instanceof K))
      return new K(t, i);
    t = t.trim().split(/\s+/).join(" "), R("comparator", t, i), this.options = i, this.loose = !!i.loose, this.parse(t), this.semver === he ? this.value = "" : this.value = this.operator + this.semver.version, R("comp", this);
  }
  var he = {};
  K.prototype.parse = function(t) {
    var i = this.options.loose ? L[m.COMPARATORLOOSE] : L[m.COMPARATOR], c = t.match(i);
    if (!c)
      throw new TypeError("Invalid comparator: " + t);
    this.operator = c[1] !== void 0 ? c[1] : "", this.operator === "=" && (this.operator = ""), c[2] ? this.semver = new C(c[2], this.options.loose) : this.semver = he;
  }, K.prototype.toString = function() {
    return this.value;
  }, K.prototype.test = function(t) {
    if (R("Comparator.test", t, this.options.loose), this.semver === he || t === he)
      return !0;
    if (typeof t == "string")
      try {
        t = new C(t, this.options);
      } catch {
        return !1;
      }
    return Ie(t, this.operator, this.semver, this.options);
  }, K.prototype.intersects = function(t, i) {
    if (!(t instanceof K))
      throw new TypeError("a Comparator is required");
    (!i || typeof i != "object") && (i = {
      loose: !!i,
      includePrerelease: !1
    });
    var c;
    if (this.operator === "")
      return this.value === "" ? !0 : (c = new G(t.value, i), Ce(this.value, c, i));
    if (t.operator === "")
      return t.value === "" ? !0 : (c = new G(this.value, i), Ce(t.semver, c, i));
    var A = (this.operator === ">=" || this.operator === ">") && (t.operator === ">=" || t.operator === ">"), O = (this.operator === "<=" || this.operator === "<") && (t.operator === "<=" || t.operator === "<"), T = this.semver.version === t.semver.version, w = (this.operator === ">=" || this.operator === "<=") && (t.operator === ">=" || t.operator === "<="), $ = Ie(this.semver, "<", t.semver, i) && (this.operator === ">=" || this.operator === ">") && (t.operator === "<=" || t.operator === "<"), j = Ie(this.semver, ">", t.semver, i) && (this.operator === "<=" || this.operator === "<") && (t.operator === ">=" || t.operator === ">");
    return A || O || T && w || $ || j;
  }, p.Range = G;
  function G(t, i) {
    if ((!i || typeof i != "object") && (i = {
      loose: !!i,
      includePrerelease: !1
    }), t instanceof G)
      return t.loose === !!i.loose && t.includePrerelease === !!i.includePrerelease ? t : new G(t.raw, i);
    if (t instanceof K)
      return new G(t.value, i);
    if (!(this instanceof G))
      return new G(t, i);
    if (this.options = i, this.loose = !!i.loose, this.includePrerelease = !!i.includePrerelease, this.raw = t.trim().split(/\s+/).join(" "), this.set = this.raw.split("||").map(function(c) {
      return this.parseRange(c.trim());
    }, this).filter(function(c) {
      return c.length;
    }), !this.set.length)
      throw new TypeError("Invalid SemVer Range: " + this.raw);
    this.format();
  }
  G.prototype.format = function() {
    return this.range = this.set.map(function(t) {
      return t.join(" ").trim();
    }).join("||").trim(), this.range;
  }, G.prototype.toString = function() {
    return this.range;
  }, G.prototype.parseRange = function(t) {
    var i = this.options.loose, c = i ? L[m.HYPHENRANGELOOSE] : L[m.HYPHENRANGE];
    t = t.replace(c, Yt), R("hyphen replace", t), t = t.replace(L[m.COMPARATORTRIM], v), R("comparator trim", t, L[m.COMPARATORTRIM]), t = t.replace(L[m.TILDETRIM], ge), t = t.replace(L[m.CARETTRIM], we), t = t.split(/\s+/).join(" ");
    var A = i ? L[m.COMPARATORLOOSE] : L[m.COMPARATOR], O = t.split(" ").map(function(T) {
      return Z(T, this.options);
    }, this).join(" ").split(/\s+/);
    return this.options.loose && (O = O.filter(function(T) {
      return !!T.match(A);
    })), O = O.map(function(T) {
      return new K(T, this.options);
    }, this), O;
  }, G.prototype.intersects = function(t, i) {
    if (!(t instanceof G))
      throw new TypeError("a Range is required");
    return this.set.some(function(c) {
      return Ne(c, i) && t.set.some(function(A) {
        return Ne(A, i) && c.every(function(O) {
          return A.every(function(T) {
            return O.intersects(T, i);
          });
        });
      });
    });
  };
  function Ne(t, i) {
    for (var c = !0, A = t.slice(), O = A.pop(); c && A.length; )
      c = A.every(function(T) {
        return O.intersects(T, i);
      }), O = A.pop();
    return c;
  }
  p.toComparators = ee;
  function ee(t, i) {
    return new G(t, i).set.map(function(c) {
      return c.map(function(A) {
        return A.value;
      }).join(" ").trim().split(" ");
    });
  }
  function Z(t, i) {
    return R("comp", t, i), t = Vt(t, i), R("caret", t), t = $t(t, i), R("tildes", t), t = zt(t, i), R("xrange", t), t = Wt(t, i), R("stars", t), t;
  }
  function U(t) {
    return !t || t.toLowerCase() === "x" || t === "*";
  }
  function $t(t, i) {
    return t.trim().split(/\s+/).map(function(c) {
      return Xt(c, i);
    }).join(" ");
  }
  function Xt(t, i) {
    var c = i.loose ? L[m.TILDELOOSE] : L[m.TILDE];
    return t.replace(c, function(A, O, T, w, $) {
      R("tilde", t, A, O, T, w, $);
      var j;
      return U(O) ? j = "" : U(T) ? j = ">=" + O + ".0.0 <" + (+O + 1) + ".0.0" : U(w) ? j = ">=" + O + "." + T + ".0 <" + O + "." + (+T + 1) + ".0" : $ ? (R("replaceTilde pr", $), j = ">=" + O + "." + T + "." + w + "-" + $ + " <" + O + "." + (+T + 1) + ".0") : j = ">=" + O + "." + T + "." + w + " <" + O + "." + (+T + 1) + ".0", R("tilde return", j), j;
    });
  }
  function Vt(t, i) {
    return t.trim().split(/\s+/).map(function(c) {
      return Ht(c, i);
    }).join(" ");
  }
  function Ht(t, i) {
    R("caret", t, i);
    var c = i.loose ? L[m.CARETLOOSE] : L[m.CARET];
    return t.replace(c, function(A, O, T, w, $) {
      R("caret", t, A, O, T, w, $);
      var j;
      return U(O) ? j = "" : U(T) ? j = ">=" + O + ".0.0 <" + (+O + 1) + ".0.0" : U(w) ? O === "0" ? j = ">=" + O + "." + T + ".0 <" + O + "." + (+T + 1) + ".0" : j = ">=" + O + "." + T + ".0 <" + (+O + 1) + ".0.0" : $ ? (R("replaceCaret pr", $), O === "0" ? T === "0" ? j = ">=" + O + "." + T + "." + w + "-" + $ + " <" + O + "." + T + "." + (+w + 1) : j = ">=" + O + "." + T + "." + w + "-" + $ + " <" + O + "." + (+T + 1) + ".0" : j = ">=" + O + "." + T + "." + w + "-" + $ + " <" + (+O + 1) + ".0.0") : (R("no pr"), O === "0" ? T === "0" ? j = ">=" + O + "." + T + "." + w + " <" + O + "." + T + "." + (+w + 1) : j = ">=" + O + "." + T + "." + w + " <" + O + "." + (+T + 1) + ".0" : j = ">=" + O + "." + T + "." + w + " <" + (+O + 1) + ".0.0"), R("caret return", j), j;
    });
  }
  function zt(t, i) {
    return R("replaceXRanges", t, i), t.split(/\s+/).map(function(c) {
      return qt(c, i);
    }).join(" ");
  }
  function qt(t, i) {
    t = t.trim();
    var c = i.loose ? L[m.XRANGELOOSE] : L[m.XRANGE];
    return t.replace(c, function(A, O, T, w, $, j) {
      R("xRange", t, A, O, T, w, $, j);
      var pe = U(T), de = pe || U(w), se = de || U($), ne = se;
      return O === "=" && ne && (O = ""), j = i.includePrerelease ? "-0" : "", pe ? O === ">" || O === "<" ? A = "<0.0.0-0" : A = "*" : O && ne ? (de && (w = 0), $ = 0, O === ">" ? (O = ">=", de ? (T = +T + 1, w = 0, $ = 0) : (w = +w + 1, $ = 0)) : O === "<=" && (O = "<", de ? T = +T + 1 : w = +w + 1), A = O + T + "." + w + "." + $ + j) : de ? A = ">=" + T + ".0.0" + j + " <" + (+T + 1) + ".0.0" + j : se && (A = ">=" + T + "." + w + ".0" + j + " <" + T + "." + (+w + 1) + ".0" + j), R("xRange return", A), A;
    });
  }
  function Wt(t, i) {
    return R("replaceStars", t, i), t.trim().replace(L[m.STAR], "");
  }
  function Yt(t, i, c, A, O, T, w, $, j, pe, de, se, ne) {
    return U(c) ? i = "" : U(A) ? i = ">=" + c + ".0.0" : U(O) ? i = ">=" + c + "." + A + ".0" : i = ">=" + i, U(j) ? $ = "" : U(pe) ? $ = "<" + (+j + 1) + ".0.0" : U(de) ? $ = "<" + j + "." + (+pe + 1) + ".0" : se ? $ = "<=" + j + "." + pe + "." + de + "-" + se : $ = "<=" + $, (i + " " + $).trim();
  }
  G.prototype.test = function(t) {
    if (!t)
      return !1;
    if (typeof t == "string")
      try {
        t = new C(t, this.options);
      } catch {
        return !1;
      }
    for (var i = 0; i < this.set.length; i++)
      if (Zt(this.set[i], t, this.options))
        return !0;
    return !1;
  };
  function Zt(t, i, c) {
    for (var A = 0; A < t.length; A++)
      if (!t[A].test(i))
        return !1;
    if (i.prerelease.length && !c.includePrerelease) {
      for (A = 0; A < t.length; A++)
        if (R(t[A].semver), t[A].semver !== he && t[A].semver.prerelease.length > 0) {
          var O = t[A].semver;
          if (O.major === i.major && O.minor === i.minor && O.patch === i.patch)
            return !0;
        }
      return !1;
    }
    return !0;
  }
  p.satisfies = Ce;
  function Ce(t, i, c) {
    try {
      i = new G(i, c);
    } catch {
      return !1;
    }
    return i.test(t);
  }
  p.maxSatisfying = Kt;
  function Kt(t, i, c) {
    var A = null, O = null;
    try {
      var T = new G(i, c);
    } catch {
      return null;
    }
    return t.forEach(function(w) {
      T.test(w) && (!A || O.compare(w) === -1) && (A = w, O = new C(A, c));
    }), A;
  }
  p.minSatisfying = Jt;
  function Jt(t, i, c) {
    var A = null, O = null;
    try {
      var T = new G(i, c);
    } catch {
      return null;
    }
    return t.forEach(function(w) {
      T.test(w) && (!A || O.compare(w) === 1) && (A = w, O = new C(A, c));
    }), A;
  }
  p.minVersion = Qt;
  function Qt(t, i) {
    t = new G(t, i);
    var c = new C("0.0.0");
    if (t.test(c) || (c = new C("0.0.0-0"), t.test(c)))
      return c;
    c = null;
    for (var A = 0; A < t.set.length; ++A) {
      var O = t.set[A];
      O.forEach(function(T) {
        var w = new C(T.semver.version);
        switch (T.operator) {
          case ">":
            w.prerelease.length === 0 ? w.patch++ : w.prerelease.push(0), w.raw = w.format();
          case "":
          case ">=":
            (!c || k(c, w)) && (c = w);
            break;
          case "<":
          case "<=":
            break;
          default:
            throw new Error("Unexpected operation: " + T.operator);
        }
      });
    }
    return c && t.test(c) ? c : null;
  }
  p.validRange = er;
  function er(t, i) {
    try {
      return new G(t, i).range || "*";
    } catch {
      return null;
    }
  }
  p.ltr = tr;
  function tr(t, i, c) {
    return Me(t, i, "<", c);
  }
  p.gtr = rr;
  function rr(t, i, c) {
    return Me(t, i, ">", c);
  }
  p.outside = Me;
  function Me(t, i, c, A) {
    t = new C(t, A), i = new G(i, A);
    var O, T, w, $, j;
    switch (c) {
      case ">":
        O = k, T = W, w = V, $ = ">", j = ">=";
        break;
      case "<":
        O = V, T = X, w = k, $ = "<", j = "<=";
        break;
      default:
        throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    if (Ce(t, i, A))
      return !1;
    for (var pe = 0; pe < i.set.length; ++pe) {
      var de = i.set[pe], se = null, ne = null;
      if (de.forEach(function(Se) {
        Se.semver === he && (Se = new K(">=0.0.0")), se = se || Se, ne = ne || Se, O(Se.semver, se.semver, A) ? se = Se : w(Se.semver, ne.semver, A) && (ne = Se);
      }), se.operator === $ || se.operator === j || (!ne.operator || ne.operator === $) && T(t, ne.semver))
        return !1;
      if (ne.operator === j && w(t, ne.semver))
        return !1;
    }
    return !0;
  }
  p.prerelease = nr;
  function nr(t, i) {
    var c = fe(t, i);
    return c && c.prerelease.length ? c.prerelease : null;
  }
  p.intersects = ar;
  function ar(t, i, c) {
    return t = new G(t, c), i = new G(i, c), t.intersects(i);
  }
  p.coerce = sr;
  function sr(t, i) {
    if (t instanceof C)
      return t;
    if (typeof t == "number" && (t = String(t)), typeof t != "string")
      return null;
    i = i || {};
    var c = null;
    if (!i.rtl)
      c = t.match(L[m.COERCE]);
    else {
      for (var A; (A = L[m.COERCERTL].exec(t)) && (!c || c.index + c[0].length !== t.length); )
        (!c || A.index + A[0].length !== c.index + c[0].length) && (c = A), L[m.COERCERTL].lastIndex = A.index + A[1].length + A[2].length;
      L[m.COERCERTL].lastIndex = -1;
    }
    return c === null ? null : fe(c[2] + "." + (c[3] || "0") + "." + (c[4] || "0"), i);
  }
})(Qe, Qe.exports);
var Gr = Qe.exports;
const Oa = /* @__PURE__ */ Mr(Gr), va = (n) => n == null ? [] : Array.isArray(n) ? n : [n], Ta = e.any().refine((n) => typeof n == "bigint", {
  message: "Value must be a BigInt"
}).transform((n) => BigInt(n));
var Br = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, Ge = Math.ceil, oe = Math.floor, te = "[BigNumber Error] ", ft = te + "Number primitive has more than 15 significant digits: ", le = 1e14, P = 14, Be = 9007199254740991, $e = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], Re = 1e7, Y = 1e9;
function Nt(n) {
  var p, R, _, S = v.prototype = { constructor: v, toString: null, valueOf: null }, B = new v(1), M = 20, F = 4, L = -7, I = 21, m = -1e7, J = 1e7, D = !1, me = 1, ae = 0, Ee = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: " ",
    // non-breaking space
    suffix: ""
  }, ge = "0123456789abcdefghijklmnopqrstuvwxyz", we = !0;
  function v(r, a) {
    var s, h, l, f, g, o, u, E, d = this;
    if (!(d instanceof v)) return new v(r, a);
    if (a == null) {
      if (r && r._isBigNumber === !0) {
        d.s = r.s, !r.c || r.e > J ? d.c = d.e = null : r.e < m ? d.c = [d.e = 0] : (d.e = r.e, d.c = r.c.slice());
        return;
      }
      if ((o = typeof r == "number") && r * 0 == 0) {
        if (d.s = 1 / r < 0 ? (r = -r, -1) : 1, r === ~~r) {
          for (f = 0, g = r; g >= 10; g /= 10, f++) ;
          f > J ? d.c = d.e = null : (d.e = f, d.c = [r]);
          return;
        }
        E = String(r);
      } else {
        if (!Br.test(E = String(r))) return _(d, E, o);
        d.s = E.charCodeAt(0) == 45 ? (E = E.slice(1), -1) : 1;
      }
      (f = E.indexOf(".")) > -1 && (E = E.replace(".", "")), (g = E.search(/e/i)) > 0 ? (f < 0 && (f = g), f += +E.slice(g + 1), E = E.substring(0, g)) : f < 0 && (f = E.length);
    } else {
      if (z(a, 2, ge.length, "Base"), a == 10 && we)
        return d = new v(r), Q(d, M + d.e + 1, F);
      if (E = String(r), o = typeof r == "number") {
        if (r * 0 != 0) return _(d, E, o, a);
        if (d.s = 1 / r < 0 ? (E = E.slice(1), -1) : 1, v.DEBUG && E.replace(/^0\.0*|\./, "").length > 15)
          throw Error(ft + r);
      } else
        d.s = E.charCodeAt(0) === 45 ? (E = E.slice(1), -1) : 1;
      for (s = ge.slice(0, a), f = g = 0, u = E.length; g < u; g++)
        if (s.indexOf(h = E.charAt(g)) < 0) {
          if (h == ".") {
            if (g > f) {
              f = u;
              continue;
            }
          } else if (!l && (E == E.toUpperCase() && (E = E.toLowerCase()) || E == E.toLowerCase() && (E = E.toUpperCase()))) {
            l = !0, g = -1, f = 0;
            continue;
          }
          return _(d, String(r), o, a);
        }
      o = !1, E = R(E, a, 10, d.s), (f = E.indexOf(".")) > -1 ? E = E.replace(".", "") : f = E.length;
    }
    for (g = 0; E.charCodeAt(g) === 48; g++) ;
    for (u = E.length; E.charCodeAt(--u) === 48; ) ;
    if (E = E.slice(g, ++u)) {
      if (u -= g, o && v.DEBUG && u > 15 && (r > Be || r !== oe(r)))
        throw Error(ft + d.s * r);
      if ((f = f - g - 1) > J)
        d.c = d.e = null;
      else if (f < m)
        d.c = [d.e = 0];
      else {
        if (d.e = f, d.c = [], g = (f + 1) % P, f < 0 && (g += P), g < u) {
          for (g && d.c.push(+E.slice(0, g)), u -= P; g < u; )
            d.c.push(+E.slice(g, g += P));
          g = P - (E = E.slice(g)).length;
        } else
          g -= u;
        for (; g--; E += "0") ;
        d.c.push(+E);
      }
    } else
      d.c = [d.e = 0];
  }
  v.clone = Nt, v.ROUND_UP = 0, v.ROUND_DOWN = 1, v.ROUND_CEIL = 2, v.ROUND_FLOOR = 3, v.ROUND_HALF_UP = 4, v.ROUND_HALF_DOWN = 5, v.ROUND_HALF_EVEN = 6, v.ROUND_HALF_CEIL = 7, v.ROUND_HALF_FLOOR = 8, v.EUCLID = 9, v.config = v.set = function(r) {
    var a, s;
    if (r != null)
      if (typeof r == "object") {
        if (r.hasOwnProperty(a = "DECIMAL_PLACES") && (s = r[a], z(s, 0, Y, a), M = s), r.hasOwnProperty(a = "ROUNDING_MODE") && (s = r[a], z(s, 0, 8, a), F = s), r.hasOwnProperty(a = "EXPONENTIAL_AT") && (s = r[a], s && s.pop ? (z(s[0], -Y, 0, a), z(s[1], 0, Y, a), L = s[0], I = s[1]) : (z(s, -Y, Y, a), L = -(I = s < 0 ? -s : s))), r.hasOwnProperty(a = "RANGE"))
          if (s = r[a], s && s.pop)
            z(s[0], -Y, -1, a), z(s[1], 1, Y, a), m = s[0], J = s[1];
          else if (z(s, -Y, Y, a), s)
            m = -(J = s < 0 ? -s : s);
          else
            throw Error(te + a + " cannot be zero: " + s);
        if (r.hasOwnProperty(a = "CRYPTO"))
          if (s = r[a], s === !!s)
            if (s)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                D = s;
              else
                throw D = !s, Error(te + "crypto unavailable");
            else
              D = s;
          else
            throw Error(te + a + " not true or false: " + s);
        if (r.hasOwnProperty(a = "MODULO_MODE") && (s = r[a], z(s, 0, 9, a), me = s), r.hasOwnProperty(a = "POW_PRECISION") && (s = r[a], z(s, 0, Y, a), ae = s), r.hasOwnProperty(a = "FORMAT"))
          if (s = r[a], typeof s == "object") Ee = s;
          else throw Error(te + a + " not an object: " + s);
        if (r.hasOwnProperty(a = "ALPHABET"))
          if (s = r[a], typeof s == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(s))
            we = s.slice(0, 10) == "0123456789", ge = s;
          else
            throw Error(te + a + " invalid: " + s);
      } else
        throw Error(te + "Object expected: " + r);
    return {
      DECIMAL_PLACES: M,
      ROUNDING_MODE: F,
      EXPONENTIAL_AT: [L, I],
      RANGE: [m, J],
      CRYPTO: D,
      MODULO_MODE: me,
      POW_PRECISION: ae,
      FORMAT: Ee,
      ALPHABET: ge
    };
  }, v.isBigNumber = function(r) {
    if (!r || r._isBigNumber !== !0) return !1;
    if (!v.DEBUG) return !0;
    var a, s, h = r.c, l = r.e, f = r.s;
    e: if ({}.toString.call(h) == "[object Array]") {
      if ((f === 1 || f === -1) && l >= -Y && l <= Y && l === oe(l)) {
        if (h[0] === 0) {
          if (l === 0 && h.length === 1) return !0;
          break e;
        }
        if (a = (l + 1) % P, a < 1 && (a += P), String(h[0]).length == a) {
          for (a = 0; a < h.length; a++)
            if (s = h[a], s < 0 || s >= le || s !== oe(s)) break e;
          if (s !== 0) return !0;
        }
      }
    } else if (h === null && l === null && (f === null || f === 1 || f === -1))
      return !0;
    throw Error(te + "Invalid BigNumber: " + r);
  }, v.maximum = v.max = function() {
    return fe(arguments, -1);
  }, v.minimum = v.min = function() {
    return fe(arguments, 1);
  }, v.random = function() {
    var r = 9007199254740992, a = Math.random() * r & 2097151 ? function() {
      return oe(Math.random() * r);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(s) {
      var h, l, f, g, o, u = 0, E = [], d = new v(B);
      if (s == null ? s = M : z(s, 0, Y), g = Ge(s / P), D)
        if (crypto.getRandomValues) {
          for (h = crypto.getRandomValues(new Uint32Array(g *= 2)); u < g; )
            o = h[u] * 131072 + (h[u + 1] >>> 11), o >= 9e15 ? (l = crypto.getRandomValues(new Uint32Array(2)), h[u] = l[0], h[u + 1] = l[1]) : (E.push(o % 1e14), u += 2);
          u = g / 2;
        } else if (crypto.randomBytes) {
          for (h = crypto.randomBytes(g *= 7); u < g; )
            o = (h[u] & 31) * 281474976710656 + h[u + 1] * 1099511627776 + h[u + 2] * 4294967296 + h[u + 3] * 16777216 + (h[u + 4] << 16) + (h[u + 5] << 8) + h[u + 6], o >= 9e15 ? crypto.randomBytes(7).copy(h, u) : (E.push(o % 1e14), u += 7);
          u = g / 7;
        } else
          throw D = !1, Error(te + "crypto unavailable");
      if (!D)
        for (; u < g; )
          o = a(), o < 9e15 && (E[u++] = o % 1e14);
      for (g = E[--u], s %= P, g && s && (o = $e[P - s], E[u] = oe(g / o) * o); E[u] === 0; E.pop(), u--) ;
      if (u < 0)
        E = [f = 0];
      else {
        for (f = -1; E[0] === 0; E.splice(0, 1), f -= P) ;
        for (u = 1, o = E[0]; o >= 10; o /= 10, u++) ;
        u < P && (f -= P - u);
      }
      return d.e = f, d.c = E, d;
    };
  }(), v.sum = function() {
    for (var r = 1, a = arguments, s = new v(a[0]); r < a.length; ) s = s.plus(a[r++]);
    return s;
  }, R = /* @__PURE__ */ function() {
    var r = "0123456789";
    function a(s, h, l, f) {
      for (var g, o = [0], u, E = 0, d = s.length; E < d; ) {
        for (u = o.length; u--; o[u] *= h) ;
        for (o[0] += f.indexOf(s.charAt(E++)), g = 0; g < o.length; g++)
          o[g] > l - 1 && (o[g + 1] == null && (o[g + 1] = 0), o[g + 1] += o[g] / l | 0, o[g] %= l);
      }
      return o.reverse();
    }
    return function(s, h, l, f, g) {
      var o, u, E, d, N, y, b, k, V = s.indexOf("."), H = M, x = F;
      for (V >= 0 && (d = ae, ae = 0, s = s.replace(".", ""), k = new v(h), y = k.pow(s.length - V), ae = d, k.c = a(
        Ae(ie(y.c), y.e, "0"),
        10,
        l,
        r
      ), k.e = k.c.length), b = a(s, h, l, g ? (o = ge, r) : (o = r, ge)), E = d = b.length; b[--d] == 0; b.pop()) ;
      if (!b[0]) return o.charAt(0);
      if (V < 0 ? --E : (y.c = b, y.e = E, y.s = f, y = p(y, k, H, x, l), b = y.c, N = y.r, E = y.e), u = E + H + 1, V = b[u], d = l / 2, N = N || u < 0 || b[u + 1] != null, N = x < 4 ? (V != null || N) && (x == 0 || x == (y.s < 0 ? 3 : 2)) : V > d || V == d && (x == 4 || N || x == 6 && b[u - 1] & 1 || x == (y.s < 0 ? 8 : 7)), u < 1 || !b[0])
        s = N ? Ae(o.charAt(1), -H, o.charAt(0)) : o.charAt(0);
      else {
        if (b.length = u, N)
          for (--l; ++b[--u] > l; )
            b[u] = 0, u || (++E, b = [1].concat(b));
        for (d = b.length; !b[--d]; ) ;
        for (V = 0, s = ""; V <= d; s += o.charAt(b[V++])) ;
        s = Ae(s, E, o.charAt(0));
      }
      return s;
    };
  }(), p = /* @__PURE__ */ function() {
    function r(h, l, f) {
      var g, o, u, E, d = 0, N = h.length, y = l % Re, b = l / Re | 0;
      for (h = h.slice(); N--; )
        u = h[N] % Re, E = h[N] / Re | 0, g = b * u + E * y, o = y * u + g % Re * Re + d, d = (o / f | 0) + (g / Re | 0) + b * E, h[N] = o % f;
      return d && (h = [d].concat(h)), h;
    }
    function a(h, l, f, g) {
      var o, u;
      if (f != g)
        u = f > g ? 1 : -1;
      else
        for (o = u = 0; o < f; o++)
          if (h[o] != l[o]) {
            u = h[o] > l[o] ? 1 : -1;
            break;
          }
      return u;
    }
    function s(h, l, f, g) {
      for (var o = 0; f--; )
        h[f] -= o, o = h[f] < l[f] ? 1 : 0, h[f] = o * g + h[f] - l[f];
      for (; !h[0] && h.length > 1; h.splice(0, 1)) ;
    }
    return function(h, l, f, g, o) {
      var u, E, d, N, y, b, k, V, H, x, X, W, Ie, K, he, G, Ne, ee = h.s == l.s ? 1 : -1, Z = h.c, U = l.c;
      if (!Z || !Z[0] || !U || !U[0])
        return new v(
          // Return NaN if either NaN, or both Infinity or 0.
          !h.s || !l.s || (Z ? U && Z[0] == U[0] : !U) ? NaN : (
            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            Z && Z[0] == 0 || !U ? ee * 0 : ee / 0
          )
        );
      for (V = new v(ee), H = V.c = [], E = h.e - l.e, ee = f + E + 1, o || (o = le, E = ce(h.e / P) - ce(l.e / P), ee = ee / P | 0), d = 0; U[d] == (Z[d] || 0); d++) ;
      if (U[d] > (Z[d] || 0) && E--, ee < 0)
        H.push(1), N = !0;
      else {
        for (K = Z.length, G = U.length, d = 0, ee += 2, y = oe(o / (U[0] + 1)), y > 1 && (U = r(U, y, o), Z = r(Z, y, o), G = U.length, K = Z.length), Ie = G, x = Z.slice(0, G), X = x.length; X < G; x[X++] = 0) ;
        Ne = U.slice(), Ne = [0].concat(Ne), he = U[0], U[1] >= o / 2 && he++;
        do {
          if (y = 0, u = a(U, x, G, X), u < 0) {
            if (W = x[0], G != X && (W = W * o + (x[1] || 0)), y = oe(W / he), y > 1)
              for (y >= o && (y = o - 1), b = r(U, y, o), k = b.length, X = x.length; a(b, x, k, X) == 1; )
                y--, s(b, G < k ? Ne : U, k, o), k = b.length, u = 1;
            else
              y == 0 && (u = y = 1), b = U.slice(), k = b.length;
            if (k < X && (b = [0].concat(b)), s(x, b, X, o), X = x.length, u == -1)
              for (; a(U, x, G, X) < 1; )
                y++, s(x, G < X ? Ne : U, X, o), X = x.length;
          } else u === 0 && (y++, x = [0]);
          H[d++] = y, x[0] ? x[X++] = Z[Ie] || 0 : (x = [Z[Ie]], X = 1);
        } while ((Ie++ < K || x[0] != null) && ee--);
        N = x[0] != null, H[0] || H.splice(0, 1);
      }
      if (o == le) {
        for (d = 1, ee = H[0]; ee >= 10; ee /= 10, d++) ;
        Q(V, f + (V.e = d + E * P - 1) + 1, g, N);
      } else
        V.e = E, V.r = +N;
      return V;
    };
  }();
  function re(r, a, s, h) {
    var l, f, g, o, u;
    if (s == null ? s = F : z(s, 0, 8), !r.c) return r.toString();
    if (l = r.c[0], g = r.e, a == null)
      u = ie(r.c), u = h == 1 || h == 2 && (g <= L || g >= I) ? Pe(u, g) : Ae(u, g, "0");
    else if (r = Q(new v(r), a, s), f = r.e, u = ie(r.c), o = u.length, h == 1 || h == 2 && (a <= f || f <= L)) {
      for (; o < a; u += "0", o++) ;
      u = Pe(u, f);
    } else if (a -= g, u = Ae(u, f, "0"), f + 1 > o) {
      if (--a > 0) for (u += "."; a--; u += "0") ;
    } else if (a += f - o, a > 0)
      for (f + 1 == o && (u += "."); a--; u += "0") ;
    return r.s < 0 && l ? "-" + u : u;
  }
  function fe(r, a) {
    for (var s, h, l = 1, f = new v(r[0]); l < r.length; l++)
      h = new v(r[l]), (!h.s || (s = ve(f, h)) === a || s === 0 && f.s === a) && (f = h);
    return f;
  }
  function ye(r, a, s) {
    for (var h = 1, l = a.length; !a[--l]; a.pop()) ;
    for (l = a[0]; l >= 10; l /= 10, h++) ;
    return (s = h + s * P - 1) > J ? r.c = r.e = null : s < m ? r.c = [r.e = 0] : (r.e = s, r.c = a), r;
  }
  _ = /* @__PURE__ */ function() {
    var r = /^(-?)0([xbo])(?=\w[\w.]*$)/i, a = /^([^.]+)\.$/, s = /^\.([^.]+)$/, h = /^-?(Infinity|NaN)$/, l = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function(f, g, o, u) {
      var E, d = o ? g : g.replace(l, "");
      if (h.test(d))
        f.s = isNaN(d) ? null : d < 0 ? -1 : 1;
      else {
        if (!o && (d = d.replace(r, function(N, y, b) {
          return E = (b = b.toLowerCase()) == "x" ? 16 : b == "b" ? 2 : 8, !u || u == E ? y : N;
        }), u && (E = u, d = d.replace(a, "$1").replace(s, "0.$1")), g != d))
          return new v(d, E);
        if (v.DEBUG)
          throw Error(te + "Not a" + (u ? " base " + u : "") + " number: " + g);
        f.s = null;
      }
      f.c = f.e = null;
    };
  }();
  function Q(r, a, s, h) {
    var l, f, g, o, u, E, d, N = r.c, y = $e;
    if (N) {
      e: {
        for (l = 1, o = N[0]; o >= 10; o /= 10, l++) ;
        if (f = a - l, f < 0)
          f += P, g = a, u = N[E = 0], d = oe(u / y[l - g - 1] % 10);
        else if (E = Ge((f + 1) / P), E >= N.length)
          if (h) {
            for (; N.length <= E; N.push(0)) ;
            u = d = 0, l = 1, f %= P, g = f - P + 1;
          } else
            break e;
        else {
          for (u = o = N[E], l = 1; o >= 10; o /= 10, l++) ;
          f %= P, g = f - P + l, d = g < 0 ? 0 : oe(u / y[l - g - 1] % 10);
        }
        if (h = h || a < 0 || // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
        N[E + 1] != null || (g < 0 ? u : u % y[l - g - 1]), h = s < 4 ? (d || h) && (s == 0 || s == (r.s < 0 ? 3 : 2)) : d > 5 || d == 5 && (s == 4 || h || s == 6 && // Check whether the digit to the left of the rounding digit is odd.
        (f > 0 ? g > 0 ? u / y[l - g] : 0 : N[E - 1]) % 10 & 1 || s == (r.s < 0 ? 8 : 7)), a < 1 || !N[0])
          return N.length = 0, h ? (a -= r.e + 1, N[0] = y[(P - a % P) % P], r.e = -a || 0) : N[0] = r.e = 0, r;
        if (f == 0 ? (N.length = E, o = 1, E--) : (N.length = E + 1, o = y[P - f], N[E] = g > 0 ? oe(u / y[l - g] % y[g]) * o : 0), h)
          for (; ; )
            if (E == 0) {
              for (f = 1, g = N[0]; g >= 10; g /= 10, f++) ;
              for (g = N[0] += o, o = 1; g >= 10; g /= 10, o++) ;
              f != o && (r.e++, N[0] == le && (N[0] = 1));
              break;
            } else {
              if (N[E] += o, N[E] != le) break;
              N[E--] = 0, o = 1;
            }
        for (f = N.length; N[--f] === 0; N.pop()) ;
      }
      r.e > J ? r.c = r.e = null : r.e < m && (r.c = [r.e = 0]);
    }
    return r;
  }
  function C(r) {
    var a, s = r.e;
    return s === null ? r.toString() : (a = ie(r.c), a = s <= L || s >= I ? Pe(a, s) : Ae(a, s, "0"), r.s < 0 ? "-" + a : a);
  }
  return S.absoluteValue = S.abs = function() {
    var r = new v(this);
    return r.s < 0 && (r.s = 1), r;
  }, S.comparedTo = function(r, a) {
    return ve(this, new v(r, a));
  }, S.decimalPlaces = S.dp = function(r, a) {
    var s, h, l, f = this;
    if (r != null)
      return z(r, 0, Y), a == null ? a = F : z(a, 0, 8), Q(new v(f), r + f.e + 1, a);
    if (!(s = f.c)) return null;
    if (h = ((l = s.length - 1) - ce(this.e / P)) * P, l = s[l]) for (; l % 10 == 0; l /= 10, h--) ;
    return h < 0 && (h = 0), h;
  }, S.dividedBy = S.div = function(r, a) {
    return p(this, new v(r, a), M, F);
  }, S.dividedToIntegerBy = S.idiv = function(r, a) {
    return p(this, new v(r, a), 0, 1);
  }, S.exponentiatedBy = S.pow = function(r, a) {
    var s, h, l, f, g, o, u, E, d, N = this;
    if (r = new v(r), r.c && !r.isInteger())
      throw Error(te + "Exponent not an integer: " + C(r));
    if (a != null && (a = new v(a)), o = r.e > 14, !N.c || !N.c[0] || N.c[0] == 1 && !N.e && N.c.length == 1 || !r.c || !r.c[0])
      return d = new v(Math.pow(+C(N), o ? r.s * (2 - De(r)) : +C(r))), a ? d.mod(a) : d;
    if (u = r.s < 0, a) {
      if (a.c ? !a.c[0] : !a.s) return new v(NaN);
      h = !u && N.isInteger() && a.isInteger(), h && (N = N.mod(a));
    } else {
      if (r.e > 9 && (N.e > 0 || N.e < -1 || (N.e == 0 ? N.c[0] > 1 || o && N.c[1] >= 24e7 : N.c[0] < 8e13 || o && N.c[0] <= 9999975e7)))
        return f = N.s < 0 && De(r) ? -0 : 0, N.e > -1 && (f = 1 / f), new v(u ? 1 / f : f);
      ae && (f = Ge(ae / P + 2));
    }
    for (o ? (s = new v(0.5), u && (r.s = 1), E = De(r)) : (l = Math.abs(+C(r)), E = l % 2), d = new v(B); ; ) {
      if (E) {
        if (d = d.times(N), !d.c) break;
        f ? d.c.length > f && (d.c.length = f) : h && (d = d.mod(a));
      }
      if (l) {
        if (l = oe(l / 2), l === 0) break;
        E = l % 2;
      } else if (r = r.times(s), Q(r, r.e + 1, 1), r.e > 14)
        E = De(r);
      else {
        if (l = +C(r), l === 0) break;
        E = l % 2;
      }
      N = N.times(N), f ? N.c && N.c.length > f && (N.c.length = f) : h && (N = N.mod(a));
    }
    return h ? d : (u && (d = B.div(d)), a ? d.mod(a) : f ? Q(d, ae, F, g) : d);
  }, S.integerValue = function(r) {
    var a = new v(this);
    return r == null ? r = F : z(r, 0, 8), Q(a, a.e + 1, r);
  }, S.isEqualTo = S.eq = function(r, a) {
    return ve(this, new v(r, a)) === 0;
  }, S.isFinite = function() {
    return !!this.c;
  }, S.isGreaterThan = S.gt = function(r, a) {
    return ve(this, new v(r, a)) > 0;
  }, S.isGreaterThanOrEqualTo = S.gte = function(r, a) {
    return (a = ve(this, new v(r, a))) === 1 || a === 0;
  }, S.isInteger = function() {
    return !!this.c && ce(this.e / P) > this.c.length - 2;
  }, S.isLessThan = S.lt = function(r, a) {
    return ve(this, new v(r, a)) < 0;
  }, S.isLessThanOrEqualTo = S.lte = function(r, a) {
    return (a = ve(this, new v(r, a))) === -1 || a === 0;
  }, S.isNaN = function() {
    return !this.s;
  }, S.isNegative = function() {
    return this.s < 0;
  }, S.isPositive = function() {
    return this.s > 0;
  }, S.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, S.minus = function(r, a) {
    var s, h, l, f, g = this, o = g.s;
    if (r = new v(r, a), a = r.s, !o || !a) return new v(NaN);
    if (o != a)
      return r.s = -a, g.plus(r);
    var u = g.e / P, E = r.e / P, d = g.c, N = r.c;
    if (!u || !E) {
      if (!d || !N) return d ? (r.s = -a, r) : new v(N ? g : NaN);
      if (!d[0] || !N[0])
        return N[0] ? (r.s = -a, r) : new v(d[0] ? g : (
          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
          F == 3 ? -0 : 0
        ));
    }
    if (u = ce(u), E = ce(E), d = d.slice(), o = u - E) {
      for ((f = o < 0) ? (o = -o, l = d) : (E = u, l = N), l.reverse(), a = o; a--; l.push(0)) ;
      l.reverse();
    } else
      for (h = (f = (o = d.length) < (a = N.length)) ? o : a, o = a = 0; a < h; a++)
        if (d[a] != N[a]) {
          f = d[a] < N[a];
          break;
        }
    if (f && (l = d, d = N, N = l, r.s = -r.s), a = (h = N.length) - (s = d.length), a > 0) for (; a--; d[s++] = 0) ;
    for (a = le - 1; h > o; ) {
      if (d[--h] < N[h]) {
        for (s = h; s && !d[--s]; d[s] = a) ;
        --d[s], d[h] += le;
      }
      d[h] -= N[h];
    }
    for (; d[0] == 0; d.splice(0, 1), --E) ;
    return d[0] ? ye(r, d, E) : (r.s = F == 3 ? -1 : 1, r.c = [r.e = 0], r);
  }, S.modulo = S.mod = function(r, a) {
    var s, h, l = this;
    return r = new v(r, a), !l.c || !r.s || r.c && !r.c[0] ? new v(NaN) : !r.c || l.c && !l.c[0] ? new v(l) : (me == 9 ? (h = r.s, r.s = 1, s = p(l, r, 0, 3), r.s = h, s.s *= h) : s = p(l, r, 0, me), r = l.minus(s.times(r)), !r.c[0] && me == 1 && (r.s = l.s), r);
  }, S.multipliedBy = S.times = function(r, a) {
    var s, h, l, f, g, o, u, E, d, N, y, b, k, V, H, x = this, X = x.c, W = (r = new v(r, a)).c;
    if (!X || !W || !X[0] || !W[0])
      return !x.s || !r.s || X && !X[0] && !W || W && !W[0] && !X ? r.c = r.e = r.s = null : (r.s *= x.s, !X || !W ? r.c = r.e = null : (r.c = [0], r.e = 0)), r;
    for (h = ce(x.e / P) + ce(r.e / P), r.s *= x.s, u = X.length, N = W.length, u < N && (k = X, X = W, W = k, l = u, u = N, N = l), l = u + N, k = []; l--; k.push(0)) ;
    for (V = le, H = Re, l = N; --l >= 0; ) {
      for (s = 0, y = W[l] % H, b = W[l] / H | 0, g = u, f = l + g; f > l; )
        E = X[--g] % H, d = X[g] / H | 0, o = b * E + d * y, E = y * E + o % H * H + k[f] + s, s = (E / V | 0) + (o / H | 0) + b * d, k[f--] = E % V;
      k[f] = s;
    }
    return s ? ++h : k.splice(0, 1), ye(r, k, h);
  }, S.negated = function() {
    var r = new v(this);
    return r.s = -r.s || null, r;
  }, S.plus = function(r, a) {
    var s, h = this, l = h.s;
    if (r = new v(r, a), a = r.s, !l || !a) return new v(NaN);
    if (l != a)
      return r.s = -a, h.minus(r);
    var f = h.e / P, g = r.e / P, o = h.c, u = r.c;
    if (!f || !g) {
      if (!o || !u) return new v(l / 0);
      if (!o[0] || !u[0]) return u[0] ? r : new v(o[0] ? h : l * 0);
    }
    if (f = ce(f), g = ce(g), o = o.slice(), l = f - g) {
      for (l > 0 ? (g = f, s = u) : (l = -l, s = o), s.reverse(); l--; s.push(0)) ;
      s.reverse();
    }
    for (l = o.length, a = u.length, l - a < 0 && (s = u, u = o, o = s, a = l), l = 0; a; )
      l = (o[--a] = o[a] + u[a] + l) / le | 0, o[a] = le === o[a] ? 0 : o[a] % le;
    return l && (o = [l].concat(o), ++g), ye(r, o, g);
  }, S.precision = S.sd = function(r, a) {
    var s, h, l, f = this;
    if (r != null && r !== !!r)
      return z(r, 1, Y), a == null ? a = F : z(a, 0, 8), Q(new v(f), r, a);
    if (!(s = f.c)) return null;
    if (l = s.length - 1, h = l * P + 1, l = s[l]) {
      for (; l % 10 == 0; l /= 10, h--) ;
      for (l = s[0]; l >= 10; l /= 10, h++) ;
    }
    return r && f.e + 1 > h && (h = f.e + 1), h;
  }, S.shiftedBy = function(r) {
    return z(r, -Be, Be), this.times("1e" + r);
  }, S.squareRoot = S.sqrt = function() {
    var r, a, s, h, l, f = this, g = f.c, o = f.s, u = f.e, E = M + 4, d = new v("0.5");
    if (o !== 1 || !g || !g[0])
      return new v(!o || o < 0 && (!g || g[0]) ? NaN : g ? f : 1 / 0);
    if (o = Math.sqrt(+C(f)), o == 0 || o == 1 / 0 ? (a = ie(g), (a.length + u) % 2 == 0 && (a += "0"), o = Math.sqrt(+a), u = ce((u + 1) / 2) - (u < 0 || u % 2), o == 1 / 0 ? a = "5e" + u : (a = o.toExponential(), a = a.slice(0, a.indexOf("e") + 1) + u), s = new v(a)) : s = new v(o + ""), s.c[0]) {
      for (u = s.e, o = u + E, o < 3 && (o = 0); ; )
        if (l = s, s = d.times(l.plus(p(f, l, E, 1))), ie(l.c).slice(0, o) === (a = ie(s.c)).slice(0, o))
          if (s.e < u && --o, a = a.slice(o - 3, o + 1), a == "9999" || !h && a == "4999") {
            if (!h && (Q(l, l.e + M + 2, 0), l.times(l).eq(f))) {
              s = l;
              break;
            }
            E += 4, o += 4, h = 1;
          } else {
            (!+a || !+a.slice(1) && a.charAt(0) == "5") && (Q(s, s.e + M + 2, 1), r = !s.times(s).eq(f));
            break;
          }
    }
    return Q(s, s.e + M + 1, F, r);
  }, S.toExponential = function(r, a) {
    return r != null && (z(r, 0, Y), r++), re(this, r, a, 1);
  }, S.toFixed = function(r, a) {
    return r != null && (z(r, 0, Y), r = r + this.e + 1), re(this, r, a);
  }, S.toFormat = function(r, a, s) {
    var h, l = this;
    if (s == null)
      r != null && a && typeof a == "object" ? (s = a, a = null) : r && typeof r == "object" ? (s = r, r = a = null) : s = Ee;
    else if (typeof s != "object")
      throw Error(te + "Argument not an object: " + s);
    if (h = l.toFixed(r, a), l.c) {
      var f, g = h.split("."), o = +s.groupSize, u = +s.secondaryGroupSize, E = s.groupSeparator || "", d = g[0], N = g[1], y = l.s < 0, b = y ? d.slice(1) : d, k = b.length;
      if (u && (f = o, o = u, u = f, k -= f), o > 0 && k > 0) {
        for (f = k % o || o, d = b.substr(0, f); f < k; f += o) d += E + b.substr(f, o);
        u > 0 && (d += E + b.slice(f)), y && (d = "-" + d);
      }
      h = N ? d + (s.decimalSeparator || "") + ((u = +s.fractionGroupSize) ? N.replace(
        new RegExp("\\d{" + u + "}\\B", "g"),
        "$&" + (s.fractionGroupSeparator || "")
      ) : N) : d;
    }
    return (s.prefix || "") + h + (s.suffix || "");
  }, S.toFraction = function(r) {
    var a, s, h, l, f, g, o, u, E, d, N, y, b = this, k = b.c;
    if (r != null && (o = new v(r), !o.isInteger() && (o.c || o.s !== 1) || o.lt(B)))
      throw Error(te + "Argument " + (o.isInteger() ? "out of range: " : "not an integer: ") + C(o));
    if (!k) return new v(b);
    for (a = new v(B), E = s = new v(B), h = u = new v(B), y = ie(k), f = a.e = y.length - b.e - 1, a.c[0] = $e[(g = f % P) < 0 ? P + g : g], r = !r || o.comparedTo(a) > 0 ? f > 0 ? a : E : o, g = J, J = 1 / 0, o = new v(y), u.c[0] = 0; d = p(o, a, 0, 1), l = s.plus(d.times(h)), l.comparedTo(r) != 1; )
      s = h, h = l, E = u.plus(d.times(l = E)), u = l, a = o.minus(d.times(l = a)), o = l;
    return l = p(r.minus(s), h, 0, 1), u = u.plus(l.times(E)), s = s.plus(l.times(h)), u.s = E.s = b.s, f = f * 2, N = p(E, h, f, F).minus(b).abs().comparedTo(
      p(u, s, f, F).minus(b).abs()
    ) < 1 ? [E, h] : [u, s], J = g, N;
  }, S.toNumber = function() {
    return +C(this);
  }, S.toPrecision = function(r, a) {
    return r != null && z(r, 1, Y), re(this, r, a, 2);
  }, S.toString = function(r) {
    var a, s = this, h = s.s, l = s.e;
    return l === null ? h ? (a = "Infinity", h < 0 && (a = "-" + a)) : a = "NaN" : (r == null ? a = l <= L || l >= I ? Pe(ie(s.c), l) : Ae(ie(s.c), l, "0") : r === 10 && we ? (s = Q(new v(s), M + l + 1, F), a = Ae(ie(s.c), s.e, "0")) : (z(r, 2, ge.length, "Base"), a = R(Ae(ie(s.c), l, "0"), 10, r, h, !0)), h < 0 && s.c[0] && (a = "-" + a)), a;
  }, S.valueOf = S.toJSON = function() {
    return C(this);
  }, S._isBigNumber = !0, S[Symbol.toStringTag] = "BigNumber", S[Symbol.for("nodejs.util.inspect.custom")] = S.valueOf, n != null && v.set(n), v;
}
function ce(n) {
  var p = n | 0;
  return n > 0 || n === p ? p : p - 1;
}
function ie(n) {
  for (var p, R, _ = 1, S = n.length, B = n[0] + ""; _ < S; ) {
    for (p = n[_++] + "", R = P - p.length; R--; p = "0" + p) ;
    B += p;
  }
  for (S = B.length; B.charCodeAt(--S) === 48; ) ;
  return B.slice(0, S + 1 || 1);
}
function ve(n, p) {
  var R, _, S = n.c, B = p.c, M = n.s, F = p.s, L = n.e, I = p.e;
  if (!M || !F) return null;
  if (R = S && !S[0], _ = B && !B[0], R || _) return R ? _ ? 0 : -F : M;
  if (M != F) return M;
  if (R = M < 0, _ = L == I, !S || !B) return _ ? 0 : !S ^ R ? 1 : -1;
  if (!_) return L > I ^ R ? 1 : -1;
  for (F = (L = S.length) < (I = B.length) ? L : I, M = 0; M < F; M++) if (S[M] != B[M]) return S[M] > B[M] ^ R ? 1 : -1;
  return L == I ? 0 : L > I ^ R ? 1 : -1;
}
function z(n, p, R, _) {
  if (n < p || n > R || n !== oe(n))
    throw Error(te + (_ || "Argument") + (typeof n == "number" ? n < p || n > R ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
}
function De(n) {
  var p = n.c.length - 1;
  return ce(n.e / P) == p && n.c[p] % 2 != 0;
}
function Pe(n, p) {
  return (n.length > 1 ? n.charAt(0) + "." + n.slice(1) : n) + (p < 0 ? "e" : "e+") + p;
}
function Ae(n, p, R) {
  var _, S;
  if (p < 0) {
    for (S = R + "."; ++p; S += R) ;
    n = S + n;
  } else if (_ = n.length, ++p > _) {
    for (S = R, p -= _; --p; S += R) ;
    n += S;
  } else p < _ && (n = n.slice(0, p) + "." + n.slice(p));
  return n;
}
var wa = Nt();
const ya = e.boolean().transform((n) => String(n)), ba = e.string().transform((n) => n === "true");
var et;
(function(n) {
  n[n.function = 0] = "function", n[n.l1_handler = 1] = "l1_handler", n[n.constructor = 2] = "constructor";
})(et || (et = {}));
const St = e.array(e.string()), Xe = e.object({
  selector: e.string(),
  offset: e.string(),
  builtins: St.optional()
}), Rt = e.object({
  CONSTRUCTOR: e.array(Xe),
  EXTERNAL: e.array(Xe),
  L1_HANDLER: e.array(Xe)
}), La = e.string(), $r = e.object({
  builtins: St,
  data: e.array(e.string())
}), tt = e.object({
  name: e.string(),
  type: e.union([e.literal("felt"), e.literal("felt*"), e.string()])
}), Xr = e.nativeEnum(et), Vr = e.object({
  inputs: e.array(tt),
  name: e.string(),
  outputs: e.array(tt),
  stateMutability: e.literal("view").optional(),
  state_mutability: e.string().optional(),
  type: Xr
}), rt = e.object({
  name: e.string(),
  type: e.union([e.literal("felt"), e.literal("felt*"), e.string()]),
  kind: e.union([e.literal("key"), e.literal("data")])
}), Hr = e.object({
  name: e.string(),
  type: e.literal("event"),
  data: e.array(rt),
  keys: e.array(rt)
}), zr = e.object({
  name: e.string(),
  members: e.array(rt),
  kind: e.literal("struct"),
  type: e.literal("event")
}), qr = e.object({
  members: e.array(tt.and(e.object({
    offset: e.number()
  }))),
  name: e.string(),
  size: e.number(),
  type: e.literal("struct")
}), Wr = e.union([zr, Hr]), Ot = e.array(e.union([Vr, Wr, qr, e.any()])), Yr = e.object({
  program: $r,
  entry_points_by_type: Rt,
  abi: Ot
}), vt = e.array(e.string()), Zr = e.object({
  type_names: e.array(e.tuple([e.number(), e.string()])),
  libfunc_names: e.array(e.tuple([e.number(), e.string()])),
  user_func_names: e.array(e.tuple([e.number(), e.string()]))
}), Ve = e.object({
  selector: e.string(),
  function_idx: e.number()
}), Kr = e.object({
  CONSTRUCTOR: e.array(Ve),
  EXTERNAL: e.array(Ve),
  L1_HANDLER: e.array(Ve)
}), Jr = e.object({
  sierra_program: vt,
  sierra_program_debug_info: Zr.optional(),
  contract_class_version: e.string(),
  entry_points_by_type: Kr,
  abi: Ot
}), Qr = e.array(e.tuple([e.number(), e.array(e.string())])), en = e.object({
  prime: e.string(),
  compiler_version: e.string(),
  bytecode: vt,
  hints: e.array(e.any()),
  pythonic_hints: Qr,
  entry_points_by_type: Rt
}), Ca = en, _a = e.union([
  Yr,
  Jr
]), Tt = cr(null), wt = () => lr(Tt), Da = () => {
  var n;
  return !!((n = wt()) != null && n.emitter);
}, Pa = ({ emitter: n, children: p }) => /* @__PURE__ */ ir(Tt.Provider, { value: {
  emitter: n
}, children: p });
let ht = !1;
const yt = () => {
  var R;
  const n = (R = wt()) == null ? void 0 : R.emitter;
  if (!n && !ht) {
    ht = !0;
    return;
  }
  return n;
}, ja = () => {
  const n = yt();
  return n ? n.emit.bind(n) : or;
}, ka = () => {
  const n = yt();
  return (R, _) => {
    ur(() => n ? n.on(R, _) : void 0, [R, _]);
  };
}, tn = e.object({
  amount: e.bigint(),
  pricePerUnit: e.bigint()
}).or(e.object({ maxFee: e.bigint() })), pt = e.object({
  feeTokenAddress: Te,
  amount: e.bigint(),
  pricePerUnit: e.bigint(),
  max: tn.optional(),
  dataGasConsumed: e.bigint().optional(),
  dataGasPrice: e.bigint().optional()
}), rn = e.object({
  deployment: pt.optional(),
  transactions: pt
}), nn = e.union([
  e.literal("critical"),
  e.literal("high"),
  e.literal("caution"),
  e.literal("info")
]), an = e.string(), sn = e.object({
  name: e.string(),
  url: e.string(),
  position: e.number()
}), He = e.object({
  address: e.string(),
  name: e.string(),
  symbol: e.string().optional(),
  decimals: e.number().optional(),
  unknown: e.boolean(),
  iconUrl: e.string().optional(),
  type: e.string()
}), dt = e.discriminatedUnion("type", [
  e.object({
    type: e.literal("amount"),
    label: e.string(),
    token: He,
    amount: e.string(),
    usd: e.string(),
    editable: e.boolean()
  }),
  e.object({
    type: e.literal("address"),
    label: e.string(),
    address: e.string(),
    addressName: e.string().optional(),
    // tbd whether it's isVerified or verified
    verified: e.boolean().optional()
  }),
  e.object({
    type: e.literal("timestamp"),
    label: e.string(),
    value: e.string()
  }),
  e.object({
    type: e.literal("token_address"),
    label: e.string(),
    token: He
  }),
  e.object({
    type: e.literal("calldata"),
    label: e.string(),
    entrypoint: e.string(),
    calldata: e.array(e.string())
  }),
  e.object({
    type: e.literal("text"),
    label: e.string(),
    text: e.string()
  }),
  e.object({
    type: e.literal("nft"),
    label: e.string(),
    token: He
  })
]), bt = e.object({
  name: e.string(),
  properties: e.array(dt),
  defaultProperties: e.array(dt).optional()
}), on = e.union([
  e.literal("verified"),
  e.literal("neutral"),
  e.literal("partial"),
  e.literal("warn")
]), cn = e.object({
  unknown_token: e.unknown().optional(),
  date_of_addition: e.string().optional(),
  contract_address: Te.optional(),
  reason: e.string().optional(),
  value: e.string().or(e.number()).optional()
}), Lt = e.object({
  reason: an,
  details: cn.optional(),
  severity: nn
}), ln = e.object({
  assessment: on,
  warnings: e.array(Lt).optional(),
  assessmentReasons: e.array(e.string()).optional(),
  assessmentDetails: e.object({
    contract_address: e.string()
  }).optional(),
  action: bt
}), Ct = e.object({
  name: e.string(),
  description: e.string(),
  logoUrl: e.string(),
  iconUrl: e.string(),
  argentVerified: e.boolean(),
  links: e.array(sn)
}), _t = e.object({
  assessment: e.union([
    e.literal("verified"),
    e.literal("neutral"),
    e.literal("partial"),
    e.literal("warn")
  ]),
  warnings: e.array(Lt).optional(),
  assessmentDetails: e.object({
    contract_address: e.string()
  }).optional(),
  targetedDapp: Ct.optional(),
  reviews: e.array(ln)
}).optional(), Dt = e.object({
  banner: e.string().nullable().optional(),
  preview: e.string().nullable().optional(),
  full: e.string().nullable().optional(),
  original: e.string().nullable().optional()
}), un = e.object({
  twitter: e.string().optional(),
  external: e.string().optional(),
  discord: e.string().optional()
}), ot = e.object({
  address: q,
  decimals: e.number().optional(),
  symbol: e.string().optional(),
  name: e.string(),
  description: e.string().optional(),
  type: e.string().optional(),
  usdValue: e.string().optional(),
  iconUrl: e.string().optional(),
  unknown: e.boolean().optional(),
  imageUrls: Dt.optional(),
  links: un.optional()
}), fn = e.object({
  tokenAddress: q,
  owner: q,
  spender: q,
  value: e.string().optional(),
  approvalForAll: e.boolean(),
  details: ot.optional()
}), hn = e.object({
  tokenAddress: q,
  from: q,
  to: q,
  tokenId: e.string().optional(),
  value: e.string().optional(),
  details: ot.optional()
}), Oe = e.union([e.string(), e.number(), e.bigint()]).transform((n) => parseInt(n.toString(), 10)), mt = {
  overallFee: Oe,
  gasPrice: Oe,
  gasUsage: Oe,
  dataGasPrice: Oe.optional(),
  dataGasConsumed: Oe.optional()
}, pn = e.object({
  ...mt,
  unit: e.string().transform((n) => n.toUpperCase()).pipe(e.literal("WEI")),
  maxFee: Oe
}).or(e.object({
  ...mt,
  unit: e.string().transform((n) => n.toUpperCase()).pipe(e.literal("FRI")),
  maxAmount: Oe,
  maxPricePerUnit: Oe
})), dn = e.object({
  type: e.string(),
  label: e.string(),
  tokenId: e.string().optional(),
  value: e.string().optional(),
  usdValue: e.string().optional(),
  token: ot,
  sent: e.boolean().optional(),
  tokenIdDetails: e.object({
    name: e.string().optional(),
    description: e.string().optional(),
    imageUrls: Dt.optional()
  }).optional()
}), mn = e.object({
  approvals: e.array(fn).optional(),
  transfers: e.array(hn).optional(),
  calculatedNonce: e.string().optional(),
  feeEstimation: pn,
  summary: e.array(dn).optional()
}), En = e.object({
  label: e.string().optional(),
  code: e.number().optional(),
  message: e.string().optional(),
  error: e.string().optional()
}), Pt = e.object({
  reviewOfTransaction: _t,
  simulation: mn,
  simulationError: e.undefined()
}), jt = e.object({
  reviewOfTransaction: _t,
  simulation: e.undefined(),
  simulationError: En
}), kt = Pt.or(jt), Ua = e.object({
  transactions: e.array(kt)
}), Fa = e.object({
  transactions: e.array(kt),
  enrichedFeeEstimation: rn.optional(),
  isBackendDown: e.boolean().default(!1).optional()
});
function xa(n) {
  return Pt.safeParse(n).success;
}
function Ma(n) {
  return jt.safeParse(n).success;
}
function Ga(n) {
  return n.error ? n.error : n.message && n.code ? `${n.code}: ${n.message}` : "Unknown error";
}
const Ut = e.object({
  network: e.string(),
  hash: e.string(),
  status: e.string(),
  blockNumber: e.number().optional(),
  transactionIndex: e.number()
}), be = e.object({
  type: e.enum(["token", "nft"]),
  tokenAddress: q,
  amount: e.string().optional(),
  fiatAmount: e.object({
    currency: e.string(),
    currencyAmount: e.number()
  }).optional().nullable()
}), ct = e.enum(["ethereum", "starknet", "zksync", "zksync2"]), gn = e.object({
  type: e.enum(["payment", "gasFee"]),
  leg: e.enum(["credit", "debit"]),
  asset: be,
  counterParty: q.optional(),
  counterPartyNetwork: ct.optional()
}), In = e.object({
  address: q,
  network: ct,
  type: e.enum(["wallet", "token"])
}), An = e.object({
  chainId: e.enum(["TESTNET", "MAINNET", "SEPOLIA"]),
  ethereumNetwork: e.enum(["mainnet", "sepolia"])
}), Nn = e.enum([
  "approval",
  "changePubKey",
  "dappInteraction",
  "deploy",
  "gift",
  "multicall",
  "payment",
  "security",
  "trade"
]), Ft = e.enum([
  "triggerEscapeGuardian",
  "triggerEscapeSigner",
  "escapeGuardian",
  "escapeSigner",
  "guardianChanged",
  "guardianBackupChanged",
  "signerChanged",
  "cancelEscape",
  "accountUpgraded",
  "multisigConfigurationUpdated"
]), Sn = e.object({
  name: e.string(),
  parameters: e.array(e.unknown()).optional()
}), Rn = e.object({
  activeAt: e.string().optional(),
  newGuardian: e.string().optional(),
  newImplementation: e.string().optional(),
  newVersion: e.string().optional()
}), Et = e.discriminatedUnion("type", [
  e.object({
    type: e.literal("deploy"),
    deployer: q,
    contractAddress: q
  }),
  e.object({
    type: e.literal("approval"),
    spender: q,
    asset: be,
    approvalType: e.string()
  }),
  e.object({
    type: e.literal("payment"),
    counterparty: q,
    leg: e.string(),
    asset: be,
    counterpartyNetwork: ct.optional()
  }),
  e.object({
    type: e.literal("trade"),
    srcAsset: be,
    destAsset: be
  }),
  e.object({
    type: e.literal("security"),
    action: Ft,
    context: Rn.optional()
  }),
  e.object({
    type: e.literal("dappInteraction"),
    dappAddress: q,
    function: Sn.optional().nullable()
    // This object is often null. It happens when we were unable to get the ABI or failed decoding the function call
  })
]), On = e.union([
  Et,
  e.object({
    type: e.literal("multicall"),
    calls: e.array(e.object({
      details: Et
    }))
  })
]), vn = e.object({
  dappId: e.string(),
  name: e.string().optional().nullable()
}), xt = e.object({
  sent: e.boolean(),
  asset: e.discriminatedUnion("type", [
    e.object({
      type: e.literal("nft"),
      tokenAddress: q,
      tokenId: e.coerce.number().optional(),
      amount: e.string().optional(),
      collectionName: e.string().optional(),
      collectionPreviewImage: e.string().optional().nullable(),
      nftName: e.string().optional().nullable(),
      nftPreviewImage: e.string().optional().nullable()
    }),
    e.object({
      type: e.literal("token"),
      tokenAddress: q,
      amount: e.string().optional(),
      fiatAmount: e.object({
        currency: e.string(),
        currencyAmount: e.coerce.string()
      }).optional().nullable()
    })
  ])
}), Tn = e.object({
  type: e.string(),
  // "gas" for example
  to: q,
  actualFee: e.object({
    type: e.string(),
    tokenAddress: q,
    amount: e.string().optional(),
    fiatAmount: e.object({
      currency: e.string(),
      currencyAmount: e.number()
    }).optional().nullable()
  })
}), Mt = e.enum(["pending", "success", "failure"]), Gt = e.object({
  compositeId: e.string(),
  id: e.string().uuid(),
  status: Mt,
  wallet: q,
  txSender: q,
  source: e.string(),
  type: Nn,
  group: e.enum(["finance", "security"]),
  submitted: e.number(),
  lastModified: e.number(),
  transaction: Ut,
  transfers: e.array(gn),
  // to be clarified
  fees: e.array(Tn).optional(),
  relatedAddresses: e.array(In).nullable(),
  network: e.string(),
  networkDetails: An.optional(),
  details: On,
  transferSummary: e.array(xt).optional(),
  dapp: vn.optional(),
  actions: e.array(bt).optional(),
  title: e.string().optional()
}), wn = e.object({
  title: e.string().optional(),
  shortTitle: e.string().optional(),
  subtitle: e.string().optional(),
  /** let's not import the keys from x-ui here */
  icon: e.string().optional()
}), yn = "native", bn = "rejected", Ln = "cancelled", Cn = "queued", Ba = Gt.pick({
  status: !0,
  actions: !0,
  submitted: !0,
  lastModified: !0,
  transferSummary: !0,
  fees: !0
}).extend({
  status: e.union([
    Mt,
    e.enum([
      bn,
      Ln,
      Cn
    ])
  ]),
  type: e.literal(yn),
  transaction: Ut.pick({
    hash: !0
  }),
  dapp: Ct.optional(),
  meta: wn.optional()
}), _n = e.array(Gt), $a = e.object({
  activities: _n,
  page: e.number(),
  pageSize: e.number(),
  totalElements: e.number(),
  totalPages: e.number()
});
function Xa(n) {
  return Ft.safeParse(n).success;
}
const Bt = (n) => xt.safeParse(n).success, Va = (n) => Bt(n) && n.asset.type === "token", Ha = (n) => Bt(n) && n.asset.type === "nft";
export {
  fa as $,
  _e as A,
  wa as B,
  sa as C,
  Ua as D,
  Zn as E,
  Ma as F,
  nt as G,
  st as H,
  Ta as I,
  Fr as J,
  ya as K,
  ba as L,
  ut as M,
  ia as N,
  Le as O,
  Dr as P,
  Pr as Q,
  jr as R,
  ra as S,
  je as T,
  kr as U,
  it as V,
  Ur as W,
  ue as X,
  ca as Y,
  la as Z,
  ua as _,
  lt as a,
  Cr as a$,
  ha as a0,
  pa as a1,
  da as a2,
  ma as a3,
  Ea as a4,
  St as a5,
  Xe as a6,
  Rt as a7,
  La as a8,
  $r as a9,
  Ir as aA,
  ke as aB,
  Ar as aC,
  Nr as aD,
  xn as aE,
  Mn as aF,
  Gn as aG,
  Bn as aH,
  $n as aI,
  Xn as aJ,
  at as aK,
  Hn as aL,
  zn as aM,
  qn as aN,
  Wn as aO,
  Yn as aP,
  Vn as aQ,
  wr as aR,
  Fe as aS,
  br as aT,
  qe as aU,
  _r as aV,
  Jn as aW,
  Qn as aX,
  ea as aY,
  ta as aZ,
  na as a_,
  tt as aa,
  Xr as ab,
  Vr as ac,
  rt as ad,
  Hr as ae,
  zr as af,
  qr as ag,
  Wr as ah,
  Ot as ai,
  Yr as aj,
  vt as ak,
  Zr as al,
  Ve as am,
  Kr as an,
  Jr as ao,
  Qr as ap,
  en as aq,
  Ca as ar,
  _a as as,
  wt as at,
  Da as au,
  Pa as av,
  yt as aw,
  ja as ax,
  ka as ay,
  It as az,
  Rr as b,
  We as b0,
  Bt as b1,
  xt as b2,
  yn as b3,
  Ba as b4,
  On as b5,
  vn as b6,
  Tn as b7,
  Gt as b8,
  wn as b9,
  bn as ba,
  Ln as bb,
  Cn as bc,
  _n as bd,
  $a as be,
  Xa as bf,
  Va as bg,
  Ha as bh,
  pt as bi,
  rn as bj,
  dt as bk,
  bt as bl,
  on as bm,
  cn as bn,
  Lt as bo,
  ln as bp,
  Ct as bq,
  Fa as br,
  xa as bs,
  Ga as bt,
  nn as bu,
  an as bv,
  oa as c,
  Sr as d,
  Lr as e,
  yr as f,
  aa as g,
  vr as h,
  Tr as i,
  Ia as j,
  Ra as k,
  Sa as l,
  Aa as m,
  Ue as n,
  Na as o,
  va as p,
  q,
  Te as r,
  Oa as s,
  Mr as t,
  gr as u,
  xe as v,
  At as w,
  Kn as x,
  ga as y,
  pn as z
};
